import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PublicGallery from '@/components/PublicGallery';
import SEO from '@/components/SEO';

const Gallery = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <SEO
        title="AI Generated Image Gallery | Inspiration & Examples"
        description="Explore stunning AI-generated images created with our bulk image generator. Get inspiration for your projects from our curated gallery of FLUX-generated artwork."
        keywords="ai image gallery, ai generated images, flux images, ai art examples, image generation showcase"
        url="/gallery"
      />
      <Header />
      <main className="pt-20">
        <PublicGallery />
      </main>
      <Footer />
    </div>
  );
};

export default Gallery;
